import { ItemCategoryTypesArray } from '../../domain/item.category.type';

export class AssetStatisticsRequest {
    ItemCategoryTypes: ItemCategoryTypesArray;
    Keyword: string;
    StartDate: Date;
    EndDate: Date;
    MaxItemCount: number;
}
